import { autosaveBadgeClasses } from './lifecareStudioClasses';

const variantClasses = 'bg-primary-surface text-primary';

const LifecareStudioPreviewUpdatingBadge = () => (
  <span className={`${autosaveBadgeClasses} ${variantClasses}`}>
    <i className="fa fa-spinner animate-spin" />
    <span>Updating preview...</span>
  </span>
);

export default LifecareStudioPreviewUpdatingBadge;
